export const DEFAULT_LANGUAGE = 'en';
export const SHARED_NAMESPACE_TRANSIFEX = 'prd1449-tm1sales-shared';
export const TMDS_NAMESPACE_TRANSIFEX = 'prd1449-tm1sales-tmds';
export const WEB_NAMESPACE_TRANSIFEX = 'prd1449-tm1sales-web';
export const ORDER_NAMESPACE_TRANSIFEX = 'prd3049-tm1orders';
